module.exports = "/reports/labor-data-bad880.html";